/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
    IcecontrolSettings,
    IcemattableSettings,
    IcepanelgroupSettings,
    IcepanelsectionSettings,
    IcepanelSettings,
    IcepanelcontainerRowSettings,
    IcepanelcontainerSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcecontrolComponent } from '../../../../icemedx-lib/src/components/icepanel/icecontrol.component';
import { IcepanelService } from '../../../../icemedx-lib/src/components/icepanel/icepanel.service';
import { IcematgridComponent } from '../../../../icemedx-lib/src/components/icepanel/icematgrid.component';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { AppService } from '../app.service';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})

export class MainComponent implements OnInit {
    title = 'app';
    inboxSettings: IcepanelcontainerSettings = null;
    @Input() onPatientRegistration: Function = (settings) => {
      this.router.navigate([this.appsvc.getBaseRoutePath('nameofpatient')]);
    };

    constructor(public router: Router, private appsvc: AppService) { }
    ngOnInit() {

        let panelTag = "Main";
        let panelKey = Iceutility.guid(false);

        let controls: IcecontrolSettings[] = [
            new IcecontrolSettings(
                "icebutton",
                {
                    text: "Patient Registration",
                    class: ["btn-danger"],
                    glyphClass: "fa-plus-circle",
                },
                null,
                {
                  onClick: this.onPatientRegistration
                }
            ),
            new IcecontrolSettings(
                "icebutton",
                {
                    text: "New Appointment",
                    class: ["btn-warning"],
                    glyphClass: "fa-plus-circle",
                    onclick: this.newAppointment
                },
                null,
                null
            )
        ];

        let sections: IcepanelsectionSettings[] = [
            new IcepanelsectionSettings(
                "InboxSection",
                {
                    class: ["yalla"],
                    styles: {
                        width: "100%"
                    }
                },
                null,
                controls,
                null)
        ];
        let panels: IcepanelSettings[] = [
            new IcepanelSettings(panelTag, panelKey, "Patient Kiosk", "", sections)];

        let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
        this.inboxSettings = new IcepanelcontainerSettings("MessageInbox", panelrows);
    } 

    newAppointment() {
      this.router.navigate([this.appsvc.getBaseRoutePath('nameofpatient')]);
    }
}
